import { BaseUrl } from "./APIURL";

//http://192.168.195.102:8083/dairy-warna/dashboard/count/getDashboardCount
export const getAdminDashboardCountAPIURL = BaseUrl + "/dashboard/count/getDashboardCount";

//http://192.168.195.102:8083/dairy-warna/transaction/reports/getGateEntryAndLabReport
export const printLabWithGateEntryReportAPIURL = BaseUrl + "/transaction/reports/getGateEntryAndLabReport";
